export const CSS_CLASSNAME = 'round-button-component';
